import styled from 'styled-components';
import { Card } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
export const StyledAutocomplete = styled(Autocomplete)`
  .MuiAutocomplete-root .MuiAutocomplete-noOptions {
    font-size: 12px;
    font-family: 'OpenSans-Regular';
  }
  .MuiInputLabel-marginDense {
    transform: translate(0, 6px) scale(1) !important;
  }
  .MuiInputLabel-animated {
    transition: color 200ms cubic-bezier(0, 0, 0.3, 2) 0ms,
      transform 200ms cubic-bezier(0, 0, 0.3, 2) 0ms;
  }
  label + .MuiInput-formControl {
    margin-top: 2px !important;
  }
  .MuiInput-underline:before {
    border-bottom: 0px !important;
  }
  .MuiInput-underline:after {
    border-bottom: 0px !important;
  }
  .MuiFormLabel-root.Mui-focused {
    display: none;
  }
  .MuiAutocomplete-endAdornment {
    display: inline-block;
  }
  .MuiAutocomplete-clearIndicator {
    visibility: visible;
  }
`;
export const AccessGraphWrapper = styled.div`
  height: 100%;
  width: auto;
  margin: 0 auto;
  overflow-y: auto;
  display: flex;
`;
export const Legend = styled.div`
  z-index: 1;
  position: absolute;
  margin-top: 48px;
  margin-left: 24px;
  width: 200px;
  border: 1px lightgray solid;
  padding: 16px 24px;
  align-self: flex-start;
  background-color: #fff;
`;
export const FilterLegend = styled.div`
  border-bottom: 2px lightgray solid;
  display: flex;
  justify-content: space-between;
  margin: 20px 30px 0 20px;
  padding-bottom: 20px;
`;
export const MainCard = styled(Card)`
  && {
    box-shadow: 0px 0px;
  }
  height: 100%;
`;
export const AccessGraphComponent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
`;
export const ErrorMessageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;
export const ErrorMessage = styled.div`
  margin-top: 15em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const LegendImageWrapper = styled.div`
  margin: 4px;
  text-align: left;
`;
export const LegendName = styled.span`
  font-size: 12px;
  font-family: 'OpenSans-Regular';
`;
export const LegendImage = styled.img`
  height: 24px;
  width: 24px;
  margin-right: 14px;
`;
export const SearchBox = styled.div`
  width: 320px;
  float: right;
  margin-left: auto;
  border-top: 1px rgba(0, 0, 0, 0.125);
  border-radius: 4px;
  border-bottom: 1px rgba(0, 0, 0, 0.125);
  padding-left: 3px;
  background-color: #fff !important;
  box-shadow: none !important;
`;
export const DropdownStyle = styled.div`
  margin-left: 38px;
`;
export const StyledSpinnerDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ClearPaths = styled.button`
  background-color: '#ccc';
  border: none;
  border-radius: 5px;
  &:hover {
    cursor: pointer;
  }
`;